import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useMonetaryAmount } from '@sorare/core/src/hooks/useMonetaryAmount';
import type { MonetaryAmountParams } from '@sorare/core/src/lib/monetaryAmount';

import { useCalculateAmounts } from './useCalculateAmounts.ts';
import { usePotentialDiscount } from './usePotentialDiscount.ts';

export const useConversionCreditForPrice = ({
  price,
  sport,
  canDiscount,
}: {
  price: MonetaryAmountParams;
  sport?: Sport;
  canDiscount?: boolean;
}) => {
  const { toMonetaryAmount } = useMonetaryAmount();

  const monetaryAmount = toMonetaryAmount(price);

  const potentialDiscount = usePotentialDiscount(
    monetaryAmount,
    monetaryAmount.referenceCurrency,
    {
      canDiscount,
      sport,
    }
  );

  const {
    totalMonetaryAmount: priceDiscountedAmount,
    conversionCreditMonetaryAmount,
    absoluteConversionCreditMonetaryAmount,
    maxDiscountMonetary,
  } = useCalculateAmounts({
    monetaryAmount,
    isFiat: false,
    creditCardFee: 0,
    activeFee: false,
    potentialDiscount,
  });

  return {
    canUseConversionCredit: !potentialDiscount?.isZero,
    priceDiscountedAmount,
    price,
    conversionCreditMonetaryAmount,
    absoluteConversionCreditMonetaryAmount,
    maxDiscountMonetary,
  };
};
